module.exports = __webpack_public_path__ + "static/img/testimony (91).3d29b775.jpg";